import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader"]

  connect() {
    // イベントハンドラーを保存（disconnect時に同一のハンドラーを削除するため）
    this.showLoaderHandler = this.showLoader.bind(this)
    this.hideLoaderWithDelayHandler = this.hideLoaderWithDelay.bind(this)
    this.contentLoadedHandler = this.contentLoaded.bind(this)

    // Turboイベントリスナーを追加
    document.addEventListener('turbo:before-visit', this.showLoaderHandler)
    document.addEventListener('turbo:load', this.hideLoaderWithDelayHandler)
    document.addEventListener('turbo:before-frame-render', this.showLoaderHandler)
    document.addEventListener('turbo:frame-render', this.hideLoaderWithDelayHandler)

    // 初期ページ読み込み完了時
    if (document.readyState === 'complete') {
      this.checkMediaLoaded()
    } else {
      window.addEventListener('load', this.contentLoadedHandler)
    }

    // フォールバックタイマーの設定（最大10秒でフェードアウト）
    this.fallbackTimeout = setTimeout(() => {
      console.log("Fallback timeout triggered after 10 seconds")
      this.hideLoader()
    }, 10000)
  }

  disconnect() {
    // イベントリスナーの削除（保存したハンドラーを使用）
    document.removeEventListener('turbo:before-visit', this.showLoaderHandler)
    document.removeEventListener('turbo:load', this.hideLoaderWithDelayHandler)
    document.removeEventListener('turbo:before-frame-render', this.showLoaderHandler)
    document.removeEventListener('turbo:frame-render', this.hideLoaderWithDelayHandler)
    window.removeEventListener('load', this.contentLoadedHandler)

    // フォールバックタイマーのクリア
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout)
    }
  }

  contentLoaded() {
    this.checkMediaLoaded()
  }

  checkMediaLoaded() {
    // 既に画像とビデオの読み込みを監視中かどうかのフラグ
    if (this.mediaCheckStarted) return
    this.mediaCheckStarted = true

    const images = document.querySelectorAll('img')
    const videos = document.querySelectorAll('video')

    let imagesLoaded = 0
    let videosLoaded = 0

    const totalMedia = images.length + videos.length

    if (totalMedia === 0) {
      this.hideLoaderWithDelay()
      return
    }

    const checkAllLoaded = () => {
      if (imagesLoaded + videosLoaded >= totalMedia) {
        this.hideLoaderWithDelay()
      }
    }

    // 画像の読み込み監視
    images.forEach((img, index) => {
      if (img.complete) {
        imagesLoaded++
        checkAllLoaded()
      } else {
        img.addEventListener('load', () => {
          imagesLoaded++
          checkAllLoaded()
        })

        img.addEventListener('error', () => {
          imagesLoaded++
          checkAllLoaded()
        })
      }
    })

    // ビデオの読み込み監視
    videos.forEach((video, index) => {
      if (video.readyState >= 3) { // HAVE_FUTURE_DATA以上
        videosLoaded++
        checkAllLoaded()
      } else {
        video.addEventListener('canplay', () => {
          videosLoaded++
          checkAllLoaded()
        })

        video.addEventListener('error', () => {
          videosLoaded++
          checkAllLoaded()
        })
      }
    })
  }

  showLoader() {
    // フォールバックタイマーのリセット
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout)
    }

    this.fallbackTimeout = setTimeout(() => {
      this.hideLoader()
    }, 10000)

    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove("hidden")
      this.loaderTarget.classList.remove("opacity-0")
    }
  }

  hideLoader() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add("opacity-0")

      setTimeout(() => {
        this.loaderTarget.classList.add("hidden")
      }, 300)
    }
  }

  hideLoaderWithDelay() {
    // フォールバックタイマーのクリア
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout)
    }

    setTimeout(() => {
      this.hideLoader()
    }, 800) // 少し長めの遅延を設定
  }
}